import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IReportAddTabResponse,
  IReportQueryOptions,
} from '../types';
import {
  REPORT_ADD_TAB_API_URL,
  REPORT_ADD_TAB_MUTATION,
} from '../constants';

export default function useReportAddTabMutation(): IContextMutationResult<IReportAddTabResponse, Error, IReportQueryOptions> {
  const { fetchPost } = useRestClient();

  return useContextMutation<IReportAddTabResponse, Error, IReportQueryOptions>({
    mutationKey: [REPORT_ADD_TAB_MUTATION],
    mutationFn: ({ reportType, widgetType, permission }: IReportQueryOptions) => fetchPost<IReportAddTabResponse>(
      REPORT_ADD_TAB_API_URL,
      null,
      {
        permission,
        urlParams: {
          reportType,
          widgetType,
        },
      },
    ),
  });
}
